import { DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import i18n from "~Shared/locales/i18n"
import { invalidateNotifications } from "~Shared/queries/notification.queries"
import { invalidateVendorLists } from "~Shared/queries/vendors/vendor.queries"
import { ThunkDispatchResult } from "~Shared/store"
import { fetchAllCostCenters } from "~Shared/store/actions/costCenter/costCenterActions"
import { fetchAllCostCenters2 } from "~Shared/store/actions/costCenter2/costCenter2Actions"
import { fetchAllEmployees } from "~Shared/store/actions/employee/employeeActions"
import { setShouldRefetchExpenses } from "~Shared/store/actions/expense/expenseActions"
import { fetchAllExpenseAccounts } from "~Shared/store/actions/expenseAccount/expenseAccountActions"
import {
    importDataFailure,
    importDataSuccess,
    importDataValidateOnlyFailure,
    importDataValidateOnlySuccess,
    importDataValidationErrors,
} from "~Shared/store/actions/import/importActions"
import { refetchExpenseTables, refetchUserRelatedTables } from "~Shared/store/actions/tables/tableActions"
import { fetchAllTeams } from "~Shared/store/actions/team/teamActions"
import { fetchAllTransactions } from "~Shared/store/actions/transaction/transactionActions"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"
import NotificationService from "../notification.service"

export const subscribeToImportResult = async (dispatch: ThunkDispatchResult, data: DocumentChangeInterface, loggedInUserId: string) => {
    const {
        fullDocument: { documentId, operationType, metaData, createdBy },
    } = data

    try {
        if (loggedInUserId === createdBy) {
            const importResultId = documentId?.toString()
            switch (operationType) {
                case OperationTypeEnum.IMPORT_DATA_VALIDATE_ONLY_SUCCESS: {
                    dispatch(importDataValidateOnlySuccess(importResultId))
                    break
                }
                case OperationTypeEnum.IMPORT_DATA_SUCCESS: {
                    dispatch(importDataSuccess(importResultId))
                    break
                }

                case OperationTypeEnum.IMPORT_DATA_VALIDATION_ERRORS:
                    dispatch(importDataValidationErrors(importResultId))
                    NotificationService.showErrorNotificationBasedOnResponseError("err", i18n.t("error:data_validation"))
                    break

                case OperationTypeEnum.IMPORT_DATA_VALIDATE_ONLY_FAILURE:
                    dispatch(importDataValidateOnlyFailure())
                    NotificationService.showErrorNotificationBasedOnResponseError("err", i18n.t("error:data_validation"))
                    break
                case OperationTypeEnum.IMPORT_DATA_FAILURE:
                    dispatch(importDataFailure())
                    NotificationService.showErrorNotificationBasedOnResponseError("err", i18n.t("error:data_upload"))
                    break
            }
        }

        if (operationType === OperationTypeEnum.IMPORT_DATA_SUCCESS) {
            await Promise.allSettled([
                invalidateNotifications(),
                invalidateVendorLists(),
                dispatch(fetchAllTeams()),
                dispatch(fetchAllExpenseAccounts()),
                dispatch(fetchAllCostCenters()),
                dispatch(fetchAllEmployees()),
                dispatch(fetchAllTransactions()),
                dispatch(fetchAllCostCenters2()),
                dispatch(setShouldRefetchExpenses(true)),
            ])
            // Refetch tables has to wait until the redux store is updated with the new data
            dispatch(refetchExpenseTables())
            dispatch(refetchUserRelatedTables())
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Import Result] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
